import { render } from "./TOTMaterials.vue?vue&type=template&id=2753bba9"
import script from "./TOTMaterials.vue?vue&type=script&lang=js"
export * from "./TOTMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__